import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=9dd6a118&lang=pug"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"
import style0 from "./Documents.vue?vue&type=style&index=0&id=9dd6a118&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports